import i18next from 'i18next';
import React from 'react';

import { Tags } from '@commons/Tags';
import DisplayNumber, { formatNumber, PRICE_NUMBER_DECIMALS } from '@commons/DisplayNumber';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

const MARGIN_DECIMALS = 2;

export const getColumns = (defaultChannelName) => [
  {
    id: 'name',
    propertyKey: 'name',
    name: i18next.t('EXTERNAL_CLIENTS.CREATION.CLONE_COLUMN_CLIENT'),
    render: (name) => (
      <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}>
        {name}
      </Text>
    ),
  },
  {
    id: 'externalReference',
    propertyKey: 'externalReference',
    name: i18next.t('EXTERNAL_CLIENTS.CREATION.CLONE_COLUMN_EXTERNAL_REFERENCE'),
    render: (externalReference) => (
      <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}>
        {externalReference || '-'}
      </Text>
    ),
  },
  {
    id: 'stores',
    propertyKey: 'stores',
    name: i18next.t('EXTERNAL_CLIENTS.CREATION.CLONE_COLUMN_STORES'),
    disableSort: true,
    render: (stores) => <Tags items={(stores || []).map(({ name }) => name)} />,
  },
  {
    id: 'priceWithTaxes',
    propertyKey: 'priceWithTaxes',
    name: i18next.t('GENERAL.PRICE_TTC'),
    tooltipText: i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_PRICE_TOOLTIP'),
    render: (priceWithTaxes) => (
      <DisplayNumber
        customNumberDecimal={PRICE_NUMBER_DECIMALS}
        font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}
        number={priceWithTaxes}
        displayCurrencyCode
      />
    ),
  },
  {
    id: 'margin',
    propertyKey: 'margin',
    name: i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_MARGIN_COLUMN'),
    tooltipText: i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_MARGIN_TOOLTIP', {
      channelName: defaultChannelName,
    }),
    render: (margin) => (
      <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}>
        {margin === null || margin === undefined
          ? '-'
          : `${formatNumber(margin, MARGIN_DECIMALS)} %`}
      </Text>
    ),
  },
];

export default { getColumns };
